import React from "react";
import { Link } from "react-router-dom";
import { StyledHoverableImage } from "./styles";

const HoverableImage = ({ src, alt, provider, showOverlay = false, title, to }) => {
  const image = (
      <StyledHoverableImage>
        <img src={src} alt={alt} className="image-card" />
        {showOverlay && (
          <div className="image-card-overlay">
            <div className="image-card-title">{title || alt}</div>
            {provider ? <div className="image-card-provider">{provider}</div> : null}
          </div>
        )}
      </StyledHoverableImage>
  );

  if (to) {
    return (
      <Link to={to} aria-label={alt} className="image-card-link">
        {image}
      </Link>
    );
  }

  return <div>{image}</div>;
};

export default HoverableImage;
